// tslint:disable:no-bitwise
export enum ComponentFeature {
    None = 0,
    Configuration = 1 << 0,
    Filter = 1 << 1,
    Skin = 1 << 2
}
